Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Divider844661908",
  {"root":"Divider844661908--root","dividerHeight":"1px","dividerBackgroundColor":"black","dividerOpacity":"initial","dividerMarginTop":"initial","dividerMarginBottom":"initial"},
  ".Divider844661908--root[data-divider844661908-customdivider]{reset:all}.Divider844661908--root:not([data-divider844661908-customdivider]){height:1px;background-color:#000;opacity:initial;margin-top:initial;margin-bottom:initial}.Divider844661908--root[data-divider844661908-vertical]{height:auto;width:1px}",
  1,
  "Divider844661908"
);
__webpack_require__.stylable.$.register(exports.default)
